import EditMedication from './EditMedication';

export default EditMedication;
